export interface EditorSaveEvent<T> {
  data?: Partial<T>;
  advance?: boolean;
}